import { render, staticRenderFns } from "./myspecialDetail.vue?vue&type=template&id=b36c3e48&scoped=true&"
import script from "./myspecialDetail.vue?vue&type=script&lang=js&"
export * from "./myspecialDetail.vue?vue&type=script&lang=js&"
import style0 from "./myspecialDetail.vue?vue&type=style&index=0&id=b36c3e48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36c3e48",
  null
  
)

export default component.exports